/**
 * Custom inline SVG icons for the side nav rail.
 */
import { useId } from 'react';

import styles from './side-nav.module.css';

export const IconAnalyticsBars = () => (
  <>
    <svg
      className={styles.legacyRailIcon}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M9.25 20.25V13.75H3.75V20.25H9.25ZM9.25 20.25H14.75M9.25 20.25V3.75H14.75V20.25M14.75 20.25H20.25V8.75H14.75V20.25Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
    <svg
      className={styles.themedRailIcon}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M0.636353 9.1212H5.30302V14.6364H0.636353V9.1212Z"
        fill="currentColor"
      />
      <path
        d="M5.30302 0.636353H9.96969V14.6364H5.30302V0.636353Z"
        fill="currentColor"
      />
      <path
        d="M9.96969 4.87878H14.6364V14.6364H9.96969V4.87878Z"
        fill="currentColor"
      />
      <path
        d="M5.30302 14.6364V9.1212H0.636353V14.6364H5.30302ZM5.30302 14.6364H9.96969M5.30302 14.6364V0.636353H9.96969V14.6364M9.96969 14.6364H14.6364V4.87878H9.96969V14.6364Z"
        stroke="var(--rl-sidenav-icon-stroke, #3b3e42)"
        strokeWidth="1.27273"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
    </svg>
  </>
);

export const IconUserAvatar = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="12" fill="#A2A9B3" />
    <path
      d="M19.884 19.7555C17.8866 21.6652 15.1154 22.8522 12.0532 22.8522C8.95636 22.8522 6.15839 21.6355 4.15625 19.6873V18.4008C4.15625 16.7627 5.56388 15.4332 7.3018 15.4332H16.7385C18.4764 15.4332 19.884 16.7627 19.884 18.4008V19.7555Z"
      fill="white"
    />
    <path
      d="M12.0197 4.5C9.45844 4.5 7.38281 6.50973 7.38281 8.9897C7.38281 11.4712 9.45844 13.4809 12.0197 13.4809C14.581 13.4809 16.6582 11.4712 16.6582 8.9897C16.6582 6.50973 14.581 4.5 12.0197 4.5Z"
      fill="white"
    />
  </svg>
);

export const IconApplicationsGrid = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M0.75 0.75H8.43182V8.43182H0.75V0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 0.75H20.25V8.43182H12.5682V0.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.75 12.5682H8.43182V20.25H0.75V12.5682Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5682 16.4091C12.5682 14.2878 14.2878 12.5682 16.4091 12.5682C18.5304 12.5682 20.25 14.2878 20.25 16.4091C20.25 18.5304 18.5304 20.25 16.4091 20.25C14.2878 20.25 12.5682 18.5304 12.5682 16.4091Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconDiscoveryCompass = () => {
  const needleHoleId = useId();
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={needleHoleId}>
        <rect width="22" height="22" fill="black" />
        <path
          d="M15.25 5.75L8.60433 8.60409L6.271 15.7708L12.9377 12.9374L15.25 5.75Z"
          fill="white"
          stroke="white"
          strokeWidth="1.5"
          strokeLinejoin="round"
        />
        <circle cx="10.771" cy="10.7708" r="2" fill="black" />
      </mask>
      <path
        d="M20.7917 10.7708C20.7917 16.3052 16.3052 20.7917 10.7708 20.7917C5.23648 20.7917 0.75 16.3052 0.75 10.7708C0.75 5.23648 5.23648 0.75 10.7708 0.75C16.3052 0.75 20.7917 5.23648 20.7917 10.7708Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        width="22"
        height="22"
        fill="currentColor"
        mask={`url(#${needleHoleId})`}
      />
    </svg>
  );
};

export const IconReportsStack = () => {
  const backCardId = useId();
  const frontCardId = useId();
  return (
    <svg
      width="24"
      height="21"
      viewBox="0 0 24 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <mask id={backCardId}>
        <rect
          x="3.13037"
          y="3.5"
          width="20.8696"
          height="17.5"
          rx="1"
          fill="white"
        />
        <rect width="20.8696" height="17.5" rx="1" fill="black" />
      </mask>
      <rect
        x="3.13037"
        y="3.5"
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        mask={`url(#${backCardId})`}
      />
      <mask id={frontCardId} fill="white">
        <rect width="20.8696" height="17.5" rx="1" />
      </mask>
      <rect
        width="20.8696"
        height="17.5"
        rx="1"
        fill="none"
        stroke="currentColor"
        strokeWidth="3"
        mask={`url(#${frontCardId})`}
      />
      <path
        d="M4.5 13.5L8.5 10L11 13L16.5 7.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="4.75"
        y1="4.25"
        x2="10.25"
        y2="4.25"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
